<template>
  <div class="psychology-tea-campus">
    <a-tabs :activeKey="tabKey" @change="onTabChange">
      <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.tab">
        <component :is="item.key" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import PsyEmotionOverview from './components/PsyEmotionOverview/index'
import PsyCampusMood from './components/PsyCampusMood/index'
export default {
  name: 'PsychologyTeaCampus',
  components: {
    PsyEmotionOverview,
    PsyCampusMood,
  },
  data() {
    return {
      tabKey: 'PsyEmotionOverview',
      tabList: [
        {
          key: 'PsyEmotionOverview',
          tab: '校园情绪概览',
        },
        {
          key: 'PsyCampusMood',
          tab: '校园心情',
        },
      ],
    }
  },
  methods: {
    onTabChange(key) {
      this.tabKey = key
    },
  },
}
</script>
<style scoped lang="less">
.psychology-tea-campus {
  /deep/ .ant-tabs-bar {
    background-color: #fff !important;
    margin: 0 !important;
    border-radius: 10px 10px 0 0;
  }
}
</style>
